import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Syllabu } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { SyllabuItem } from "../SyllabuItem";

const syllabuController = new Syllabu();

export function ListSyllabu(props) {
  const { reload, onReload } = props;
  const [syllabus, setSyllabus] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setSyllabus(null);
        const response = await syllabuController.getSyllabus(accessToken);
        setSyllabus(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken]);

  if (!syllabus) return <Loader active inline="centered" />;
  if (size(syllabus) === 0) return "No existen planes de estudios registrados";

  return map(syllabus, (syllabu) => (
    <SyllabuItem key={syllabu.id} syllabu={syllabu} onReload={onReload} />
  ));
}
